import type { FunctionReturnType } from "convex/server";
import type { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";

type GradingSession = NonNullable<
  FunctionReturnType<typeof api.ai.grading.publicQueries.getSessionById>
>;

export type GradingAnalysis = NonNullable<GradingSession["analysisResults"]>;

export type GradingBuyerPrice = NonNullable<GradingSession["buyerPrice"]>;

export interface GradingFeedbackAccess {
  gradingSessionId: Id<"gradingSessions">;
  feedbackToken: string;
}

export interface GradingPhoto {
  storageId: Id<"_storage">;
  previewUrl: string;
}

export function gradingPhase(started: boolean, status: string | undefined) {
  if (!started) return "upload" as const;
  if (status === "completed") return "results" as const;
  if (status === "failed") return "error" as const;
  return "analyzing" as const;
}
